import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

export interface MapPlotRequestDetail {
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  location: string;
  chiban: string;
  remarks: string;
  tags: string[];
  additionalFields?: Record<string, { value: string }> | null;
  realEstateType?: "土地" | "建物" | "区分建物";
}

export interface MapPlotRequestData {
  mapPlotRequestId?: number;
  name: string;
  tags: string[];
  details: MapPlotRequestDetail[];
  additionalFields?: string;
}

export interface MapPlotRequestResponse {
  id: number;
  name: string;
  uploadFileUri: string | null;
  count: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * 地図プロットリクエストデータを作成するAPI
 */
export const useCreateMapPlotRequest = (): SWRMutationResponse<
  MapPlotRequestResponse,
  never,
  "map/plot-request",
  MapPlotRequestData
> => {
  const { apiClient } = useApiClient();
  const url = "map/plot-request";

  const fetcher = async (
    url: string,
    { arg }: { arg: MapPlotRequestData }
  ): Promise<MapPlotRequestResponse> => {
    return (await apiClient.post<MapPlotRequestResponse>(url, arg)).data;
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
